import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBank,
  faUserCircle,
  faHashtag,
  faEdit
} from "@fortawesome/free-solid-svg-icons";
import Info from "./Info";

const AccountInfo = ({accountInfo, showEdit}) => {
  return (
    <div className="relative bg-white rounded-2xl shadow-md p-6 text-gray-900">
      {!showEdit &&  <div className="absolute right-4 top-2 text-gray-900 cursor-pointer"><Link to={"/user/my-royalties/update-account"}><FontAwesomeIcon icon={faEdit} /></Link>   </div>}
      <h2 className="text-xl font-bold text-yellow-600 mb-4 flex items-center gap-2">
        <FontAwesomeIcon icon={faBank} /> Account Info
      </h2>
      <div className="space-y-3">
        <Info icon={faUserCircle} name={accountInfo?.accountName || "NA"} />
        <Info icon={faHashtag} name={accountInfo?.accountNumber || "0000000000"} />
        <Info icon={faBank} name={accountInfo?.bankName || "NA"} />
      </div>
    </div>
  );
};
export default AccountInfo;
